export const SUPPORT_LINK = 'https://www.avetta.com/contact-us';